import { Button, Card, CardBody, CardHeader, Checkbox, Divider, Input, Modal, ModalBody, ModalContent, ModalFooter, ModalHeader, TableCell, TableRow, Chip } from "@nextui-org/react";
import RootAdmin from "../../../../components/layouts/RootAdmin";
import { PencilSquareIcon, PlusIcon, TrashIcon } from "@heroicons/react/24/outline";
import useSWR from "swr";
import { getFetcher } from "../../../../services/api";
import usePeriod from "../../../../hooks/master-data/usePeriod";
import { format } from "date-fns";
import { id } from "date-fns/locale";
import ClientTablePagination from "../../../../components/elements/ClientTablePagination";
import ControlledInput from "../../../../components/elements/ControlledInput";

export default function IndexPage() {
  const { data, isLoading, mutate } = useSWR(`/api/period/all`, getFetcher);
  const {
    onClickEdit,
    onCloseForm,
    onSubmitForm,
    onClickDelete,
    onSubmitDelete,

    modalAlert: { isOpenModalAlert, onOpenChangeModalAlert },
    modalForm: { onOpenModalForm, isOpenModalForm, onOpenChangeModalForm },
    hookForm: {
      register,
      control,
      handleSubmit,
      formState: { isSubmitting, isEdit },
    },
  } = usePeriod({ mutate });

  const header = ["Nama", "Tanggal Mulai Periode", "Tanggal Akhir Periode", "Batas Waktu Submit Pelaporan", "Status Periode", "Aksi"];

  const content = (item) => (
    <TableRow key={item.id}>
      <TableCell>{item.name}</TableCell>
      <TableCell>{format(item.startPeriodDate, "PPP", { locale: id })}</TableCell>
      <TableCell>{format(item.endPeriodDate, "PPP", { locale: id })}</TableCell>
      <TableCell>{format(item.finalizationDeadline, "PPP", { locale: id })}</TableCell>
      <TableCell>
        {item.isActive ? (
          <Chip color="success" variant="flat" size="sm">
            Aktif
          </Chip>
        ) : (
          <Chip color="danger" variant="flat" size="sm">
            Tidak Aktif
          </Chip>
        )}
      </TableCell>
      <TableCell>
        <div className="flex items-center gap-1">
          <Button size="sm" isDisabled={isSubmitting} color="warning" isIconOnly onPress={() => onClickEdit(item)}>
            <PencilSquareIcon className="size-4" />
          </Button>
          <Button size="sm" onPress={() => onClickDelete(item.id)} color="danger" isIconOnly>
            <TrashIcon className="size-4" />
          </Button>
        </div>
      </TableCell>
    </TableRow>
  );

  return (
    <RootAdmin>
      <Card className="w-full mt-3" radius="sm">
        <CardHeader>
          <p className="text-md">Daftar Periode</p>
        </CardHeader>
        <Divider />
        <CardBody>
          <div className="mb-5">
            <Button onPress={onOpenModalForm} size="sm" color="primary" startContent={<PlusIcon className="size-4 stroke-2" />}>
              Tambah
            </Button>
          </div>
          <ClientTablePagination data={data} isLoading={isLoading} header={header} content={content} />
        </CardBody>
      </Card>

      <Modal scrollBehavior="inside" isOpen={isOpenModalForm} onOpenChange={onOpenChangeModalForm} onClose={onCloseForm} isDismissable={false} isKeyboardDismissDisabled={false}>
        <ModalContent>
          {(onClose) => (
            <>
              <ModalHeader>{isEdit ? "Edit" : "Tambah"} Periode</ModalHeader>
              <ModalBody>
                <form onSubmit={handleSubmit(onSubmitForm)}>
                  <div className="flex flex-col gap-3 mb-6">
                    <ControlledInput label="Nama" name="name" type="text" isRequired={true} control={control} />
                    <ControlledInput label="Tanggal Mulai Periode" name="startPeriodDate" type="date" isRequired={true} control={control} />
                    <ControlledInput label="Tanggal Akhir Periode" name="endPeriodDate" type="date" isRequired={true} control={control} />
                    <ControlledInput label="Batas Waktu Submit Pelaporan" name="finalizationDeadline" type="date" isRequired={true} control={control} />

                    <Checkbox {...register("isActive")}>Aktif</Checkbox>
                  </div>

                  <div className="flex items-center gap-1">
                    <Button isLoading={isSubmitting} isDisabled={isSubmitting} type="submit" color="primary">
                      {isEdit ? "Edit" : "Tambah"}
                    </Button>
                    <Button isDisabled={isSubmitting} color="danger" variant="faded" onPress={onClose}>
                      Batal
                    </Button>
                  </div>
                </form>
              </ModalBody>
              <ModalFooter />
            </>
          )}
        </ModalContent>
      </Modal>

      <Modal isOpen={isOpenModalAlert} onOpenChange={onOpenChangeModalAlert}>
        <ModalContent>
          {(onClose) => (
            <>
              <ModalHeader className="flex flex-col gap-1">Konfirmasi Hapus</ModalHeader>
              <ModalBody>
                <p>Apakah Anda yakin ingin menghapus periode ini?</p>
              </ModalBody>
              <ModalFooter>
                <Button color="default" variant="light" onPress={onClose}>
                  Batal
                </Button>
                <Button
                  color="danger"
                  onPress={() => {
                    onSubmitDelete();
                    onClose();
                  }}
                >
                  Hapus
                </Button>
              </ModalFooter>
            </>
          )}
        </ModalContent>
      </Modal>
    </RootAdmin>
  );
}
